import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import masterServiceAccount from '../masterServiceAccount';
export default fillCrudMetadataGaps({
  label: 'Conta de Serviço',
  labelPlural: 'Contas de Serviço',
  name: 'ServiceAccount',
  namePlural: 'ServiceAccounts',
  authorization: authorization('clientConsultant', 'master'),
  deletable: false,
  dynamoDB: {
    tableName: 'SpearServiceAccount'
  },
  columns: ['id', 'name', 'apiKey', 'enabled', 'createDate', 'clientId', 'clientName', 'ownerId'],
  fields: masterServiceAccount.fields.filter(f => !f.custom_onlyMasterServiceAccount),
  filter: masterServiceAccount.filter.filter(f => !f.custom_onlyMasterServiceAccount)
});